import axios from 'axios'

/*global grecaptcha*/

class Newsletter {
    // apiUrl = 'https://api.pawscout.com/statistic/api/v2/website/newsletter'
    apiUrl = 'https://pawscout.com/api/subscribe.php'
    successMsg = 'Subscribed successfully'

    constructor (form) {
        this.form = form

        this.form.addEventListener('submit', this.submit.bind(this))
    }

    submit (e) {
        e.preventDefault()

        this.form.submit.classList.add('loading')

        debugger
        grecaptcha.ready(async () => {
            try {
                const captchaToken = await grecaptcha.execute('6LdFA9wUAAAAAMpgxOlT7Qxb5bM8PfYe0_36SPCj', { action: 'submit' })
                const response = await axios.post(this.apiUrl, {
                    contact: this.form.email.value,
                    captchaToken
                })

                if (response && response.status === 200) {
                    this.form.submit.classList.remove('loading')
                    this.form.submit.innerHTML = this.successMsg
                } else {
                    this.form.submit.classList.remove('loading')
                }
            } catch (e) {
                console.error(e)
                this.form.submit.classList.remove('loading')
            }
        })
    }
}

export default Newsletter
